/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleWithIdDto } from '../../models/article-with-id-dto';

export interface ShopGetArticles$Params {
  'x-trace-id'?: string;
}

export function shopGetArticles(http: HttpClient, rootUrl: string, params?: ShopGetArticles$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ArticleWithIdDto>>> {
  const rb = new RequestBuilder(rootUrl, shopGetArticles.PATH, 'get');
  if (params) {
    rb.header('x-trace-id', params['x-trace-id'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ArticleWithIdDto>>;
    })
  );
}

shopGetArticles.PATH = '/api/shop/articles';
